import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { CONFIG } from 'src/global-config';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

import { usePathname } from '../../../routes/hooks';

// ----------------------------------------------------------------------

// Tenant
const TenantListPage = lazy(() => import('src/pages/tenants/list'));
const TenantDetailsPage = lazy(() => import('src/pages/tenants/details'));
// ----------------------------------------------------------------------

function SuspenseOutlet() {
  const pathname = usePathname();
  return (
    <Suspense key={pathname} fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  );
}

const dashboardLayout = () => (
  <DashboardLayout>
    <SuspenseOutlet />
  </DashboardLayout>
);

export const tenantRoutes: RouteObject[] = [
  {
    path: 'tenant',
    element: CONFIG.auth.skip ? dashboardLayout() : <AuthGuard>{dashboardLayout()}</AuthGuard>,
    children: [
      { index: true, element: <TenantListPage /> },
      { path: 'list', element: <TenantListPage /> },
      { path: ':id/details', element: <TenantDetailsPage /> },
    ],
  },
];
